import {useEffect} from "react";
import {useDispatch} from "react-redux";
import {API_OPTIONS} from '../utils/Constants'
import { addCastDetails } from "../utils/detailsSlice";
const useCast = (Movie_Id) =>{
    const dispatch = useDispatch();
       const  getCastNames = async () =>{
    const data = await fetch('https://api.themoviedb.org/3/movie/'+ Movie_Id + '/credits?language=en-US', API_OPTIONS)
    const json = await data.json();
    dispatch(addCastDetails(json)); 
}
useEffect(()=>{
    getCastNames();
},[])}

export default useCast;